/* =======================================================================
   Philosophy — Sezione "La nostra filosofia" (4 card colorate)
   =======================================================================
   Le 4 card sono in src/data/copy.js → sezione "philosophy" → array "cards".
   Per aggiungere/rimuovere card, modifica quella lista.
   ======================================================================= */
import { useLang } from "@/context/LanguageContext";

export default function Philosophy({ copy }) {
  const { tr } = useLang();
  return (
    <section
      id="filosofia"
      data-testid="philosophy"
      className="bg-[#EAE3D2] text-[#2C2C2A] py-24 lg:py-36"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 lg:mb-24 items-end">
          <div className="lg:col-span-7">
            <p className="text-[0.72rem] tracking-[0.32em] uppercase text-[#737554] mb-6">
              — {tr(copy.philosophy.overline)}
            </p>
            <h2 className="font-serif font-light italic text-[clamp(2.4rem,5vw,4.4rem)] leading-[1.02] tracking-tight">
              {tr(copy.philosophy.title)}
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#D7D0B7]">
          {copy.philosophy.cards.map((c, i) => (
            <article
              key={i}
              data-testid={`philosophy-card-${i}`}
              className="group relative bg-[#F7F4EB] p-8 lg:p-10 min-h-[320px] flex flex-col justify-between transition-colors duration-500 hover:bg-[#2C2C2A] hover:text-[#F7F4EB]"
            >
              <div className="flex items-center gap-3">
                <span className="font-handwriting text-3xl text-[#BC472A] group-hover:text-[#E6C9A8]">
                  /{String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-[0.7rem] tracking-[0.3em] uppercase">{tr(c.tag)}</span>
              </div>
              <div>
                <h3 className="font-serif text-3xl lg:text-[2rem] leading-tight mb-4">{tr(c.title)}</h3>
                <p className="text-[0.95rem] font-light leading-relaxed opacity-85">{tr(c.body)}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
